import Snackbar from './Notif';

export default Snackbar;


// WEBPACK FOOTER //
// ./src/components/Notif/index.js